/* eslint-disable react/no-unused-state */
import React from 'react';
import { Form, Select, Input, DatePicker, Radio } from '@block/plug';
import { datejs, isEmpty } from '@block/utils';
import { SuccessFile } from '@src/types/self';
import { OcrUpload } from '../../components';
import Url from './url';
import { doAction, getPattern } from '../../utils';
import './index.scss';
import { PersonalInfoGet } from './types';

const labelWidth = 120;

interface Props {
  ref: React.RefObject<any>;
}
interface State {
  placeStatus: boolean;
  companyEmail: string[];
}
class PersonBackground extends React.Component<Props, State> {
  dataChanged: boolean;

  private formRef = React.createRef<Form>();

  constructor(props: Props) {
    super(props);
    this.state = {
      placeStatus: undefined,
      companyEmail: [],
    };
    this.dataChanged = false;
  }

  async componentDidMount() {
    this.getCompanyEmail();
    const data = await doAction<PersonalInfoGet>(Url.getInfo, {}, null);
    const { nationalityDictIndex } = data;
    this.setState({
      placeStatus: nationalityDictIndex !== 'CHN',
    });
    this.formRef.current?.setAllFieldsValue(data);
  }

  getCompanyEmail = async () => {
    const companyEmail = await doAction(Url.email);
    this.setState({ companyEmail });
  };

  // 获取国籍
  handleFetchNationality = async (filter = '') => {
    const data = await doAction(Url.getNationality, { filter }, null);
    return data.pageList;
  };

  // 获取省份
  handleFetchProvince = async (filter = '') => {
    const data = await doAction(Url.getProvince, {
      filter,
      parentIndex: 'CHN',
    });
    return data.pageList;
  };

  // 获取城市
  handleFetchCity = async (filter = '', province: string = undefined) => {
    if (province) {
      const data = await doAction(Url.getCity, {
        filter,
        parentExtIndex: 'CHN',
        parentIndex: province,
      });
      return data.pageList;
    }
    return [];
  };

  // 获取民族
  handleFetchNationData = async (filter = '') => {
    const { nationalityDictIndex } = this.formRef.current.getFieldsValueIncludeHide();
    if (nationalityDictIndex) {
      const data = await doAction(Url.getNation, {
        filter,
        parentIndex: nationalityDictIndex,
      });
      return data.pageList;
    }
    return [];
  };

  handleFetchNationDataByCHN = async (filter = '') => {
    const data = await doAction(Url.getNation, {
      filter,
      parentIndex: 'CHN',
    });
    return data.pageList;
  };

  // 获取证件类型
  handleFetchIDType = async (filter = '') => {
    const data = await doAction(Url.getIDType, {
      filter,
    });
    return data.pageList;
  };

  // 获取户口类型
  handleFetchAccountType = async (filter = '') => {
    const data = await doAction(
      Url.getRegisterType,
      {
        filter,
      },
      null,
    );
    return data.pageList;
  };

  // 获取政治面貌
  handleFetchPolitical = async (filter = '') => {
    const data = await doAction(Url.getPolitical, {
      filter,
    });
    return data.pageList;
  };

  handleFetchAreaList = async (filter = '') => {
    const data = await doAction(Url.getAreaList, {
      filter,
    });
    return data.pageList;
  };

  handleFetchPeriod = (value) => {
    const current = new Date().getFullYear();
    const date = new Date(value).getFullYear();
    return current - date >= 28;
  };

  handleFetchRelation = async (filter = '') => {
    const data = await doAction(Url.getRelation, {
      filter,
    });
    return data.pageList;
  };

  handleFieldValueChange = (code: keyof PersonalInfoGet, value) => {
    const ref = this.formRef.current;

    if (code === 'indentityCardFrontUrl') {
      // TODO
      // 身份证正面照
      const { fileInfo, ocrState, type } = {} as any;
      const { fileId, fileName } = fileInfo || {};
      const hasEdit = false; // 生日 性别 是否可以编辑的标示
      const noOcrType = null;
      this.formRef.current?.setFieldsValue({
        indentityCardFrontId: fileId,
        indentityCardFrontName: fileName,
      });
      if (ocrState === 'success' && !noOcrType.includes(type)) {
        const tempData: any = {};
        ref?.setFieldsValue(tempData);
        ref?.validateFields();
        const obj: any = {
          birthdayStatus: hasEdit,
        };
        if (tempData.birthdayStr) {
          obj.birthdayStr = tempData.birthdayStr;
        }
        this.setState(obj);
      }
    }
    if (code === 'indentityCardBackUrl') {
      // TODO
      // 身份证背面照
      const { fileId, fileName } = {} as any;
      this.formRef.current?.setFieldsValue({
        indentityCardBackId: fileId,
        indentityCardBackName: fileName,
      });
    }

    if (code === 'certTypeDictIndex') {
      // 证件类型
      let { birthday, birthdayStr, gender } = ref.getFieldsValueIncludeHide();
      if (value === 'NID' || value === 'OLDNID') {
        birthday = null;
        birthdayStr = null;
        gender = null;
      }
      ref?.setFieldsValue({
        certNumber: null,
        birthday,
        birthdayStr,
        gender,
        genderDictName: null,
      });
    }

    if (code === 'certNumber') {
      // 证件号码
      let { birthday, birthdayStr, gender } = ref.getFieldsValueIncludeHide();
      const { certTypeDictIndex } = ref.getFieldsValueIncludeHide();
      if (certTypeDictIndex === 'NID' && value.length === 18) {
        const year = value.substring(6, 10);
        const month = value.substring(10, 12);
        const day = value.substring(12, 14);
        const date = [year, month, day].join('-');
        birthday = new Date(date).getTime();
        birthdayStr = [year, month, day].join('-');
        gender = parseInt(value.substring(17, 1), 10) % 2 ? 'M' : 'F';
        ref.clearValidateStatus(['gender', 'birthday']);
      } else if (certTypeDictIndex === 'OLDNID' && value.length === 15) {
        const year = `19${value.substring(6, 8)}`;
        const month = value.substring(8, 10);
        const day = value.substring(10, 12);
        const date = [year, month, day].join('-');
        birthday = new Date(date).getTime();
        birthdayStr = [year, month, day].join('-');
        gender = parseInt(value.substring(14, 1), 10) % 2 ? 'M' : 'F';
        ref.clearValidateStatus(['gender', 'birthday']);
      }
      ref?.setFieldsValue({
        certNumber: value,
        birthday,
        birthdayStr,
        gender,
        genderDictName: gender === 'M' ? '男' : '女',
      });
    }

    if (code === 'birthday') {
      // 生日
      ref?.setFieldsValue({
        birthdayStr: datejs(value).format('YYYY-MM-DD'),
      });
    }

    if (code === 'gender') {
      // 性别
      ref?.setFieldsValue({
        genderDictName: value === 'M' ? '男' : '女',
      });
    }

    if (code === 'nationalityDictIndex') {
      // 国籍
      this.setState({
        placeStatus: value !== 'CHN',
      });
    }

    if (code === 'hometownProvinceDictIndex') {
      // 籍贯 省份
      ref?.setFieldsValue({
        hometownCityDictIndex: null,
        hometownCityDictName: null,
      });
    }
    if (code === 'area') {
      ref?.setFieldsValue({
        area: value.code,
      });
    }
    this.dataChanged = true;
  };

  handleSuccess = (type: string, file: SuccessFile) => {
    const { fileId, fileName, fileUrl } = file;
    const ref = this.formRef.current;
    if (type === 'front') {
      ref?.setFieldsValue({
        indentityCardFrontId: fileId,
        indentityCardFrontName: fileName,
        indentityCardFrontUrl: fileUrl,
      });
    } else {
      ref?.setFieldsValue({
        indentityCardBackId: fileId,
        indentityCardBackName: fileName,
        indentityCardBackUrl: fileUrl,
      });
    }
    fileId && ref.clearValidateStatus([type === 'front' ? 'indentityCardFrontUrl' : 'indentityCardBackUrl']);
    this.dataChanged = true;
  };

  // 保存
  handleSave = async () => {
    const ref = this.formRef.current;
    if (ref?.validateFields()) {
      const data = await doAction(Url.save, this.handleFetchFinalData());
      return data === undefined ? false : data;
    }
    return false;
  };

  // 获取最终组织数据
  handleFetchFinalData = () => this.formRef.current.getFieldsValueIncludeHide();

  render() {
    const { ref } = this.props;
    const { companyEmail } = this.state;
    // eslint-disable-next-line @typescript-eslint/no-this-alias
    const self = this;
    return (
      <div className="personback" ref={ref}>
        <Form
          ref={this.formRef}
          labelWidth={`${labelWidth}px`}
          onFieldValueChange={this.handleFieldValueChange}
          className="personback__form"
        >
          <Form.Item
            formItemKey="certTypeDictIndex"
            labelInValue={false}
            formItemLabel="certTypeDictName"
            span={11}
            label="证件类型："
            required
            message="证件类型不能为空"
          >
            <Select
              toFormItem
              filterable
              keyField="dictIndex"
              labelField="dictValue"
              onFetchData={(filter) => this.handleFetchIDType(filter)}
              placeholder="请选择"
              loadingMessage="正在搜索..."
              notFoundMessage="无数据"
              popLayer={{
                getContainer: () => document.querySelector('.personback__form'),
              }}
            />
          </Form.Item>
          <Form.Item span={11} />
          <Form.Item
            formItemKey="indentityCardFrontUrl"
            span={7}
            required
            message="不能为空"
            labelWidth={0}
            style={{
              paddingLeft: `${labelWidth}px`,
            }}
          >
            <OcrUpload
              toFormItem
              fileType="11"
              url={Url.upload}
              parent={this.formRef}
              label="证件正面"
              onChange={(file) => this.handleSuccess('front', file)}
            />
          </Form.Item>
          <Form.Item
            formItemKey="indentityCardBackUrl"
            span={6}
            offset={0.2}
            labelWidth={0}
            required
            message="不能为空"
          >
            <OcrUpload
              toFormItem
              fileType="12"
              url={Url.upload}
              parent={this.formRef}
              label="证件反面"
              onChange={(file) => this.handleSuccess('back', file)}
            />
          </Form.Item>
          <Form.Item span={11} />

          <Form.Item
            formItemKey="certNumber"
            span={11}
            label="证件号码："
            required
            rules={[
              { required: true, message: '证件号码不能为空' },
              {
                validator(rule, value, callback) {
                  const { certTypeDictIndex } = self.formRef.current.getFieldsValueIncludeHide();
                  let str;
                  if (certTypeDictIndex === 'NID') {
                    str =
                      '^[1-9]\\d{5}(18|19|([23]\\d))\\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\\d{3}[0-9Xx]$';
                  } else if (certTypeDictIndex === 'OLDNID') {
                    str = '^[1-9]\\d{5}\\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\\d{3}$';
                  } else {
                    str = '^[0-9a-zA-Z]+$';
                  }
                  const pattern = getPattern(str);
                  if (pattern && !pattern.test(value)) {
                    callback('请输入有效的证件号码');
                  } else {
                    callback();
                  }
                },
              },
            ]}
          >
            <Input toFormItem placeholder="请输入" maxLength={50} />
          </Form.Item>

          <Form.Item formItemKey="birthday" span={11} offset={2} label="生日：" required message="生日不能为空">
            <DatePicker
              toFormItem
              valueFormat="timestamp"
              popLayer={{
                getContainer: () => document.querySelector('.personback__form'),
              }}
            />
          </Form.Item>

          <Form.Item formItemKey="gender" span={11} label="性别：" required message="性别不能为空">
            <Radio.Group toFormItem>
              <Radio value="M">男</Radio>
              <Radio value="F">女</Radio>
            </Radio.Group>
          </Form.Item>
          <Form.Item
            formItemKey="nationalityDictIndex"
            labelInValue={false}
            formItemLabel="nationalityDictName"
            span={11}
            offset={2}
            label="国籍："
            required
            message="国籍不能为空"
          >
            <Select
              toFormItem
              filterable
              keyField="dictIndex"
              labelField="dictValue"
              onFetchData={(filter) => this.handleFetchNationality(filter)}
              placeholder="请选择"
              loadingMessage="正在搜索..."
              notFoundMessage="无数据"
              popLayer={{
                getContainer: () => document.querySelector('.personback__form'),
              }}
            />
          </Form.Item>

          <Form.Item labelWidth={0}>
            <div className="base-form__dividing" />
          </Form.Item>

          <Form.Item labelWidth={0}>
            <span className="base-form__title">联系方式</span>
          </Form.Item>
          <Form.Item formItemKey="area" span={5} label="移动电话：" required message="不能为空">
            <Select
              toFormItem
              filterable
              keyField="code"
              labelField="name"
              // renderLabel={(value) => `${value.name}(${value.code})`}
              renderInputLabel={(option) => `+${option.value}`}
              renderOptionContent={(option: any) => `${option.name}(+${option.code})`}
              onFetchData={(filter) => this.handleFetchAreaList(filter)}
              placeholder="请选择"
              loadingMessage="正在搜索..."
              notFoundMessage="无数据"
              popLayer={{
                width: 150,
                getContainer: () => document.querySelector('.personback__form'),
              }}
            />
          </Form.Item>
          <Form.Item
            className="person__space"
            formItemKey="phone"
            span={6}
            labelWidth={0}
            rules={[
              { required: true, message: '不能为空' },
              {
                validator(rule, value, callback) {
                  const str = '^([0-9]{3,24})$';
                  // if (nationalityDictIndex && nationalityDictIndex === 'CHN') {
                  //   str = '^1\\d{10}$';
                  // } else {
                  //   str = '^([0-9]{3,24})$';
                  // }
                  const pattern = getPattern(str);
                  if (pattern && !pattern.test(value)) {
                    callback('请输入有效的手机号');
                  } else if (isEmpty(value)) {
                    callback('手机号不能为空');
                  } else {
                    callback();
                  }
                },
              },
            ]}
          >
            <Input toFormItem maxLength={50} />
          </Form.Item>
          <Form.Item
            formItemKey="email"
            span={11}
            offset={2}
            label="个人邮箱："
            rules={[
              { required: true, message: '邮箱不能为空' },
              {
                validator(rule, value, callback) {
                  const str = '^([a-zA-Z0-9]+[_|.]?)*[a-zA-Z0-9]+@([a-zA-Z0-9]+[_.]?)*[a-zA-Z0-9]+.[a-zA-Z]{2,3}$';
                  const pattern = getPattern(str);
                  // 增加邮箱后缀校验，禁止公司邮箱
                  const domain = value.split('@')[1];
                  if (pattern && !pattern.test(value)) {
                    callback('邮箱格式不正确');
                  } else if (value && companyEmail?.includes(domain)) {
                    callback('请填写个人邮箱（不能填写公司邮箱）');
                  } else {
                    callback();
                  }
                },
              },
            ]}
          >
            <Input toFormItem maxLength={30} />
          </Form.Item>

          <Form.Item labelWidth={0}>
            <div className="base-form__dividing" />
          </Form.Item>

          <Form.Item labelWidth={0}>
            <span className="base-form__title">紧急联系人</span>
          </Form.Item>
          <Form.Item
            formItemKey="relationName"
            span={11}
            label="姓名："
            required
            message="不能为空"
            rules={[
              { required: true, message: '不能为空' },
              {
                validator: (rule, value, callback) => {
                  const { name } = this.formRef.current.getFieldsValueIncludeHide();
                  if (value && value.length < 2) {
                    callback('请填写紧急联系人的完整姓名');
                  } else if (value && name && value === name) {
                    callback('紧急联系人不能是本人');
                  } else {
                    callback();
                  }
                },
              },
            ]}
          >
            <Input toFormItem maxLength={50} />
          </Form.Item>
          <Form.Item
            formItemKey="relationDictIndex"
            labelInValue={false}
            formItemLabel="relationDictName"
            span={11}
            offset={2}
            label="与本人关系："
            required
            message="不能为空"
          >
            <Select
              toFormItem
              filterable
              keyField="dictIndex"
              labelField="dictValue"
              onFetchData={(filter) => this.handleFetchRelation(filter)}
              placeholder="请选择"
              loadingMessage="正在搜索..."
              notFoundMessage="无数据"
              popLayer={{
                getContainer: () => document.querySelector('.personback__form'),
              }}
            />
          </Form.Item>
          <Form.Item
            formItemKey="relationPhone"
            span={11}
            label="紧急联系电话："
            rules={[
              { required: true, message: '紧急联系电话不能为空' },
              {
                validator: (rule, value, callback) => {
                  const str = '^([0-9]{3,24})$';
                  const pattern = getPattern(str);
                  const { phone } = this.formRef.current.getFieldsValueIncludeHide();
                  if (pattern && !pattern.test(value)) {
                    callback('请输入有效的紧急联系电话');
                  } else if (value === phone) {
                    callback('紧急联系人电话不能与本人电话一致');
                  } else {
                    callback();
                  }
                },
              },
            ]}
          >
            <Input toFormItem maxLength={50} />
          </Form.Item>
          <Form.Item span={6} />
        </Form>
      </div>
    );
  }
}

export default PersonBackground;
